import _ from 'lodash';

/*
 * Helper functions for dealing with input field values.
 *
 * EL-378: provide unit tests for those functions
 */

/**
 * Tests whether a value is empty. Empty is defined as undefined, null, '' or NaN.
 * Cannot just test value because then it would miss `false` and `0` and other falsy
 * but legitimate values
 *
 * @param {any} value - value to test
 * @returns {boolean} true or false if value is empty
 */
export function isEmptyValue(value) {
    return value === undefined || value === null || value === '' || _.isNaN(value);
}

/**
 * Tests whether a value is nil. Nil is defined as undefined or null.
 *
 * @param {any} value - value to test
 * @returns {boolean} true or false if value is nil
 */
export function isNilValue(value) {
    return value === undefined || value === null;
}

/**
 * Tests whether or not two values are the same. Values are considered the same
 * if both are "empty" or they are strictly equivalent.
 *
 * @param {*} val1 - The first value to compare
 * @param {*} val2 - The second value to compare
 * @returns {boolean} - True if values are the same
 */
export function isValueSame(val1, val2) {
    return (isEmptyValue(val1) && isEmptyValue(val2)) || val1 === val2;
}

/**
 * Get the value to display regarding field type.
 *
 * @param {string} fieldType HTML5 input type
 * @param {any} value
 *
 * @returns {any} value to render
 */
export function getValueForInput(fieldType, value) {
    if (fieldType !== 'number') {
        return value || '';
    }

    if (_.isNumber(value) && !_.isNaN(value)) {
        return value;
    }
    const intValue = parseInt(value);
    if (_.isNaN(intValue)) {
        return '';
    }
    return intValue;
}
